var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-col p-3" },
        [
          _c(
            "div",
            { staticClass: "pb-3 flex justify-between items-center w-full" },
            [
              _c(
                "el-row",
                { staticClass: "w-full pb-3", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "search song name" },
                        on: { change: _vm.searchMusic },
                        model: {
                          value: _vm.filters,
                          callback: function($$v) {
                            _vm.filters = $$v
                          },
                          expression: "filters"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "flex items-center", attrs: { span: 6 } },
                    [
                      _c("Button", {
                        attrs: { label: "Apply" },
                        on: { clicked: _vm.searchMusic }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "p-2" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "sync"] },
                            on: { click: _vm.resetMusic }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "pb-3 w-full" },
            [
              _c(
                "el-col",
                { staticClass: "flex flex-row gap-3", attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "md:w-50 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 0
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 0
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium" },
                            [
                              _vm._v(
                                "\n              Waiting for Review (" +
                                  _vm._s(_vm.countWaitingForReviewByArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 1
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 1
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium" },
                            [
                              _vm._v(
                                "\n              Under Review (" +
                                  _vm._s(_vm.countUnderReviewByArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 2
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 2
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium" },
                            [
                              _vm._v(
                                "\n              Approved (" +
                                  _vm._s(_vm.countApprovedByArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 3
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 3
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium " },
                            [
                              _vm._v(
                                "\n              Rejected (" +
                                  _vm._s(_vm.countRejectedByArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 4
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 4
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium " },
                            [
                              _vm._v(
                                "\n              Published (" +
                                  _vm._s(_vm.countPublishedByArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "data-tables-server",
            {
              ref: "tableMusic",
              attrs: {
                data: _vm.data,
                total: _vm.total,
                "pagination-props": { background: true, pageSizes: [20] }
              },
              on: { "query-change": _vm.onChangeTable }
            },
            [
              _vm._l(_vm.titles, function(title) {
                return _c("el-table-column", {
                  key: title.prop,
                  attrs: {
                    prop: title.prop,
                    label: title.label,
                    sortable: "custom"
                  }
                })
              }),
              _vm._v(" "),
              _c("el-table-column", {
                staticClass: "text-center",
                attrs: { label: "Publish", width: "90px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.published
                                ? "Published"
                                : "Not Published"
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Song", width: "250px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "audio",
                          {
                            staticClass: "audio-player",
                            staticStyle: { width: "240px" },
                            attrs: {
                              controls: "",
                              src: scope.row.file,
                              id: "audioPlayer" + scope.row.id,
                              controlsList: "nodownload",
                              type: "audio/mp3",
                              preload: "none"
                            }
                          },
                          [
                            _vm._v(
                              "\n            Audio tag not supported\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Actions", width: "120px", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "static inline-block text-left container-action"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "rounded-md shadow-sm" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "py-1" },
                                  [
                                    _c(
                                      "VueCustomTooltip",
                                      {
                                        attrs: {
                                          label: "Detail",
                                          position: "is-right"
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                            on: {
                                              click: function($event) {
                                                return _vm.detail(
                                                  $event,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "text-white",
                                              attrs: { icon: ["fa", "eye"] }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "VueCustomTooltip",
                                      {
                                        attrs: {
                                          label: "Edit",
                                          position: "is-left"
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "p-2 w-8 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none",
                                            on: {
                                              click: function($event) {
                                                _vm.isShowModalEdit = true
                                                _vm.editSong = scope.row
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "text-white",
                                              attrs: {
                                                icon: ["fa", "pencil-alt"]
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          ref: "detailSong",
          attrs: {
            isShowingModal: _vm.isShowingDetailModal,
            isLoading: _vm.isLoading,
            title: "Song Details"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingDetailModal = !_vm.isShowingDetailModal
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("SongDetail", {
                attrs: {
                  "toggle-reset": _vm.isShowingDetailModal,
                  song: _vm.song
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addSongModal",
          attrs: {
            isShowingModal: _vm.isShowModalAdd,
            "label-submit": "Submit",
            title: "Add Song"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowModalAdd = !_vm.isShowModalAdd
            },
            save: function($event) {
              return _vm.submit()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("AddSong", {
                ref: "addSong",
                attrs: {
                  "toggle-reset": _vm.isShowModalAdd,
                  "user-id": _vm.artistid,
                  "musicverse-cut": _vm.musicverseCut,
                  "artist-cut": _vm.artistCut
                },
                on: { "on-submit-song": _vm.onSubmitSong }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "EditSongModal",
          attrs: {
            isShowingModal: _vm.isShowModalEdit,
            "label-submit": "Save",
            title: "Edit Song"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowModalEdit = !_vm.isShowModalEdit
            },
            save: function($event) {
              return _vm.submitEdit()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("EditSong", {
                ref: "editSong",
                attrs: {
                  "toggle-reset": _vm.isShowModalEdit,
                  song: _vm.editSong,
                  "user-id": _vm.artistid,
                  "musicverse-cut": _vm.musicverseCut,
                  "artist-cut": _vm.artistCut
                },
                on: { "on-edit-song": _vm.onSubmitEditSong }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5d7958a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5d7958a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artist/ListSong.vue
// module id = null
// module chunks = 